'use client';

import { useDispatch, useSelector } from 'react-redux';
import { logOut, logIn } from './userSlice';
import { useLazyLogoutQuery, useLazyLoginCheckQuery } from '@api/api';
import { RootState } from '../store';
import { userState } from './userSlice';
import { unsetCustomer } from '../customerSlice/customerSlice';
import { setCookie } from 'cookies-next';
import { useEffect } from 'react';

export function useLogoutHandler() {
  const [logout] = useLazyLogoutQuery();
  const dispatch = useDispatch();
  const cookies = [
    'userId',
    'accessToken',
    'firstName',
    'lastName',
    'customerId',
    'customerType',
    'customerName',
  ];
  return () => {
    logout();
    cookies.forEach((cookie: string) => {
      setCookie(cookie, '');
    });
    dispatch(logOut());
  };
}

export function useLoginHandler() {
  const dispatch = useDispatch();
  const cookies = ['userId', 'accessToken', 'firstName', 'lastName'];
  return (payload: userState) => {
    const expire = new Date();
    expire.setTime(new Date().getTime() + 3600000 * 24 * 14);
    cookies.forEach((cookie: string) => {
      setCookie(cookie, payload[cookie as keyof userState], {
        expires: expire,
      });
    });
    dispatch(logIn(payload));
  };
}

export function LoggedInValidator() {
  const userLoggedIn = useSelector((state: RootState) => {
    return state.user.loggedIn;
  });
  const [loginCheck, { data }] = useLazyLoginCheckQuery();
  const logout = useLogoutHandler();
  useEffect(() => {
    if (userLoggedIn) {
      loginCheck();
    }
  }, [userLoggedIn]);
  useEffect(() => {
    if (userLoggedIn && data && data.status !== 200) {
      logout();
      unsetCustomer();
    }
  }, [data]);
  return null;
}
